import React from 'react'
import usePage from '../../../hooks/usePage'

const Home = () => {
  usePage('Home')

  return (
    <div>
      <h1>
        Home
      </h1>
    </div>
  )
}

export default Home
